import React from 'react';
import styled from 'styled-components'
import { useLocation, useNavigate } from 'react-router-dom';
import { DeviceType } from '../../shared/enum/EnumRepository';
import { useDeviceStore } from '../../shared/store/deviceStore';
import logoWithName from '../../asset/gnb/logo_v2.png';
import logoFit from '../../asset/gnb/logo_fit.png';

const LeftTopIsland: React.FC = () => {
  const { pathname } = useLocation();
  const { deviceType } = useDeviceStore();
  const navigate = useNavigate();

  const isMobile = deviceType === DeviceType.MOBILE;

  const isLandingPage = () => {
    return pathname === `/`;
  }
  const isPolicyPage = () => {
    return pathname.includes('/policy');
  }
  const isExhibitionsPage = () => pathname === '/exhibitions';
  // const isOnBoardingPage = () => {
  //   return pathname.includes('/onboard');
  // }

  const isVisible = (
    !isLandingPage()
    && !isPolicyPage()
    && !isExhibitionsPage()
  );
  // const isVisible = (!isLandingPage() && !isPolicyPage() && !isOnBoardingPage());
  if (isVisible) {
    return null;
  }


  const handleLogoClick = () => {
    if (!isLandingPage()) {
      navigate('/');
    }
  }

  return (
    <GnbSection
      $isMobile={isMobile}>
        <LogoContainer>
          <LogoIconBtn src={isMobile ? logoFit : logoWithName} alt='architrave logo' onClick={handleLogoClick}/>
        </LogoContainer>
    </GnbSection>
  );
}

const GnbSection = styled.section<{ $isMobile: boolean;}>`
  position: fixed;
  top: ${({ $isMobile }) => $isMobile ? 'clamp(22px, 3vw, 26px);' : 'clamp(26px, 2vw, 32px)'};
  left: ${({ $isMobile }) => $isMobile ? 'clamp(20px, 3vw, 26px)' : 'clamp(26px, 2vw, 32px)'};

  display: flex;
  z-index: 3;
`;

const LogoContainer = styled.article`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LogoIconBtn = styled.img`
  width: auto;
  height: clamp(12px, 1.5vw, 15px);
  cursor: pointer;
`

export default LeftTopIsland;


